import type { ExperienceDetails } from '@atlassian/jira-business-experience-tracking/src/types.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils';
import type { FlagConfiguration } from '@atlassian/jira-flags';
import messages from './messages.tsx';

const PACKAGE_NAME = 'jiraBusinessList';

const descriptionSelector = functionWithCondition(
	() => expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false),
	() => messages.rankItem404ErrorDescriptionIssueTermRefresh,
	() => messages.rankItem404ErrorDescription,
);

export const RANK_ISSUE_EXPERIENCE: ExperienceDetails = {
	experience: 'rankIssue',
	packageName: PACKAGE_NAME,
	teamName: 'keystone',
};

export const RANK_ITEM_FAIL_GENERIC_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.rankItemErrorTitle,
	description: messages.rankItemErrorDescription,
	messageId:
		'business-list.controllers.use-rank-issue.rank-item-fail-generic-flag.error.error.rank-item-fail-generic-flag',
	messageType: 'transactional',
};

// remove on exp 'issue-terminology-refresh-m2-replace' cleanup
export const RANK_ITEM_FAIL_404_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.rankItemErrorTitle,
	description: descriptionSelector(),
	messageId:
		'business-list.controllers.use-rank-issue.rank-item-fail-404-flag.error.error.rank-item-fail-404-flag',
	messageType: 'transactional',
};

export const RANK_ITEM_FAIL_404_FLAG_NEW: FlagConfiguration = {
	type: 'error',
	title: messages.rankItemErrorTitle,
	description: messages.rankItem404ErrorDescriptionIssueTermRefresh,
	messageId:
		'business-list.controllers.use-rank-issue.rank-item-fail-404-flag-new.error.error.rank-item-fail-404-flag-new',
	messageType: 'transactional',
};

// remove on exp 'issue-terminology-refresh-m2-replace' cleanup
export const RANK_ITEM_FAIL_403_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.rankItemErrorTitle,
	description: descriptionSelector(),
	messageId:
		'business-list.controllers.use-rank-issue.rank-item-fail-403-flag.error.error.rank-item-fail-403-flag',
	messageType: 'transactional',
};

export const RANK_ITEM_FAIL_403_FLAG_NEW: FlagConfiguration = {
	type: 'error',
	title: messages.rankItemErrorTitle,
	description: messages.rankItem403ErrorDescriptionIssueTermRefresh,
	messageId:
		'business-list.controllers.use-rank-issue.rank-item-fail-403-flag-new.error.error.rank-item-fail-403-flag-new',
	messageType: 'transactional',
};
